'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:network:sendSms');
}

var _invoke = require('../invoke');

/**
 * 发送预填充内容了的短信
 *
 * 支持版本
 * + iHotel/6.6
 *
 * @memberof network
 * @static
 * @name sendSms
 * @example
 *  hbnb.network.sendSms({
 *      "recipients": 110, // 电话号码，支持多个
 *      "text": "help" // 发送到的文字内容
 *  })
 */

module.exports = function(mobile, content) {
    _invoke('device', 'send_sms', {
        "recipients": mobile, // 电话号码，支持多个
        "text": content // 发送到的文字内容
    });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hfe/hbnb/network/send-sms.js
// module id = wNTm
// module chunks = 0